
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import {
  pageVisit,
  getCouponList,
  getClassifyProductType,
  productNaturePrice,
  addCart
} from '@/services/http';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Price,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  loading: boolean = false // 加载

  couponList: [] = [] // 优惠券商品列表

  pageNo: number = 1 // 当前页数

  pageSize: number = 10 // 每页显示条数

  totalnumber: number = 0 // 总条数

  productType: any = '' // 分类搜索

  naturelist: any[] = [] // 规格列表

  priceList: any[] = [] // 价格列表

  orderByprice: any = '' // 价格排序

  classifyList: any[] = [] // 分类列表

  firstActive: any = '' // 选中的第一分类

  firstIndex: any = '' // 选中的第一分类下标

  couponIndex: number = 0

  secondActive: any[] = [] // 选中的第二分类

  secondProductType: any[] = [] // 选中的第二分类列表

  selectArr: any[] = [] // 所选规格列表

  selectId: string = ''

  thirdActive: number = 1 // 1综合、2价格

  priceSort: any = 'asc' // asc上升、desc下降

  // 选中重量
  weight: string = ''

  dialogVisible: boolean = false

  // 是否下架
  isshelf: boolean = false

  // 选中价格
  selectPrice: string = ''

  @Action('card/setCardNum') setCardNum!: Function

  async created() {
    this.loading = true;
    await this.getClassifyProductType();
    await this.getCouponList();
    this.loading = false;
    this.pageVisit();
  }

  @Watch('$route')
  routechange() {
    this.getCouponList();
  }

  // 全部点击回调
  handleAll() {
    if (this.firstActive === '') return;
    this.firstActive = '';
    this.secondActive = [];
    this.firstIndex = '';
    this.productType = '';
    this.thirdActive = 1;
    this.pageNo = 1;
    this.getCouponList();
  }

  // 一级分类点击回调
  setSecond(id: number, index: number) {
    if (this.firstActive === id) return;
    this.firstActive = id;
    this.secondActive = [];
    this.firstIndex = index;
    this.productType = id;
    this.pageNo = 1;
    this.getCouponList();
  }

  // 二级分类点击回调
  getClassify(item: any) {
    if (this.secondActive.length === 0) {
      this.secondActive.push(item.id);
      this.getCouponList();
    } else {
      if (this.secondActive.filter((e) => e === item.id).length > 0) {
        for (let i = 0; i < this.secondActive.length; i += 1) {
          if (this.secondActive[i] === item.id) {
            this.secondActive.splice(i, 1);
            break;
          }
        }
      } else {
        this.secondActive.push(item.id);
      }
      this.getCouponList();
    }
  }

  // 综合、价格回调
  setThird(num: number) {
    this.pageNo = 1;
    if (this.thirdActive === num && num === 1) return;
    const asc: any = document.querySelector('.el-icon-caret-top');
    const desc: any = document.querySelector('.el-icon-caret-bottom');
    if (num === 1) {
      asc.style.color = '#666';
      desc.style.color = '#666';
      this.priceSort = 'asc';
      this.orderByprice = '';
      this.thirdActive = num;
      this.getCouponList();
    } else if (num === 2) {
      this.priceSort = this.priceSort === 'asc' ? 'desc' : 'asc';
      if (this.priceSort === 'asc') {
        asc.style.color = '#666';
        desc.style.color = '#0043ff';
      } else {
        asc.style.color = '#0043ff';
        desc.style.color = '#666';
      }
      this.thirdActive = num;
      this.orderByprice = this.priceSort === 'asc' ? 'desc' : 'asc';
      this.getCouponList();
    }
  }

  // 获取商品规格价格
  private async getNaturePrice(productId: number, key: number) {
    const res: any = await productNaturePrice({
      productId,
      companyId: 1
    });
    this.couponIndex = key;
    this.naturelist = res.data.data.nature;
    this.priceList = res.data.data.price;
    this.dialogVisible = true;
    const arr: any[] = [];
    if (this.priceList.length > 0) {
      this.priceList[0].natureIds
        .split(',')
        .map(Number)
        .forEach((value: any, index: any) => {
          const obj = {
            index,
            id: value,
            natureName: this.naturelist[index].data.filter((e: any) => e.id === value)[0]
              .natureName,
            natureValue: this.naturelist[index].data.filter((e: any) => e.id === value)[0]
              .natureValue
          };
          arr.push(obj);
        });
    }
    this.selectArr = arr;
  }

  // 加入购物车
  async addCart(id: any, num: number) {
    const anchor = readCookie('anchor');
    const res: any = await addCart({
      productPriceId: id,
      num,
      equip: anchor ? anchor.equip : '',
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    if (res.data.code === 100) {
      this.dialogVisible = false;
      this.$message.success('加入购物车成功');
      this.setCardNum();
    } else {
      this.$message.error(res.data.message);
    }
  }

  goCard() {
    this.$router.push('/card');
  }

  // 获取商品优惠券列表
  private async getCouponList() {
    this.loading = true;
    try {
      const res: any = await getCouponList({
        couponId: this.$route.query.id,
        productType: this.productType,
        secondProductType: this.secondActive.join(','),
        productName: '',
        orderByprice: this.orderByprice,
        // eslint-disable-next-line no-nested-ternary
        // type: this.firstActive === '' ? '' : this.secondActive === '' ? 1 : 2,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        companyId: 1
      });
      const page = res && res.data && res.data.code === 100 ? res.data.data : null;
      const list = page && Array.isArray(page.list) ? page.list : [];
      list.forEach((value: object) => {
        this.$set(value, 'val', 1);
      });
      this.couponList = list;
      this.totalnumber = page && page.total ? page.total : 0;
    } catch (e) {
      this.couponList = [];
      this.totalnumber = 0;
    } finally {
      this.loading = false;
    }
  }

  // 获取商品优惠券分类列表
  private async getClassifyProductType() {
    try {
      const res: any = await getClassifyProductType({
        couponId: this.$route.query.id,
        companyId: 1
      });
      const list = res && res.data && res.data.code === 100 ? res.data.data : [];
      this.classifyList = Array.isArray(list) ? list : [];
    } catch (e) {
      this.classifyList = [];
    }
  }

  selectNature(obj: any, index: number) {
    const { id, natureValue, natureName } = obj;
    const target = {
      id,
      index,
      natureValue,
      natureName
    };
    if (!this.isshelf) {
      if (this.selectArr.length === 0) {
        this.selectArr.push(target);
      } else {
        let boon = false;
        this.selectArr.forEach((value, indexs) => {
          if (value.id === id) {
            this.selectArr = this.selectArr.filter((e) => e.id !== id);
            boon = true;
          } else if (value.index === index) {
            boon = true;
            this.selectArr[indexs].id = id;
            this.selectArr[indexs].natureValue = natureValue;
            this.selectArr[indexs].natureName = natureName;
          }
        });
        if (!boon) {
          this.selectArr.push(target);
        }
      }
      if (this.selectArr.length === this.naturelist.length) {
        const price = this.priceList.filter(
          (e: any) => e.natureIds.split(',').sort().join(',')
            === this.selectArr
              .map((ele: any) => ele.id)
              .sort()
              .join(',')
        );
        this.selectPrice = String(price[0].price);
        this.selectId = price[0].id;
        const { weight } = this.priceList.filter((e) => e.id === this.selectId)[0];
        this.weight = weight;
      } else {
        this.selectPrice = '';
        this.selectId = '';
      }
    }
  }

  // 没有所属规格置灰
  private checkDisabled(id: number, index: number) {
    let flagCheck = false;
    const naturearrCheck = this.priceList.map((e: any) => e.natureIds.split(','));
    if (this.selectArr.length > 0) {
      naturearrCheck.forEach((_item) => {
        let flagSum = 0;
        const lines: any[] = [];
        this.selectArr.forEach((item) => {
          lines.push(item.index);
          if (_item.indexOf(`${item.id}`) !== -1) {
            flagSum += 1;
          }
        });
        if (_item.indexOf(`${id}`) !== -1 && flagSum >= 1) {
          if (
            (flagSum >= this.selectArr.length - 1 && lines.indexOf(index) !== -1)
            || flagSum >= this.selectArr.length
          ) {
            flagCheck = true;
          }
        }
      });
      if (flagCheck || (this.selectArr.length === 1 && index === this.selectArr[0].index)) {
        return false;
      }

      return true;
    }
    return false;
  }

  private goDetails(id: string) {
    this.$router.push(`/details?id=${id}`);
  }

  handleCurrentChange(val: number) {
    this.pageNo = val;
    this.getCouponList();
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.getCouponList();
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 2,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
